/// <amd-module name="typeahead/features/HierarchicalSuggestion" />
/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../typings/typeahead/suggestionsProvider.d.ts"/>

import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {IEssSuggestionResult} from "typeahead/core/Suggestion";
import {PackageType, TypeaheadUtils} from "typeahead/core/TypeaheadUtils";
import {addFeatureFlag} from "typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils";

const configuration: IStripingConfiguration[] = [{
    lobs: ["HOTELS", "FLIGHTS", "RAILS", "PACKAGES"],
}];

const featureFlag = "ta_hierarchy";

export class HotelHierarchyPlugin implements IRequestUrlParamModifier, ISuggestionsModifier {
    // This feature is turned on in general. It is turned off off for specific client(s) to assist an investigation.
    // For details of that investigation, see:
    // https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/4368
    //
    // Should opting out of features becomes permenantly useful, it should be implemented through the suggestionPicker
    // tag. The task is tracked with https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/4192 .
    private static readonly inapplicableClients: string[] = ["Flights.Search"];

    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: any):
            JQueryPromise<ISuggestServiceQueryParams> {
        if (HotelHierarchyPlugin.inapplicableClients.lastIndexOf(context.clientId) < 0 &&
        TypeaheadUtils.getPackageType() !== PackageType.FlightCar) {
            return addFeatureFlag(featureFlag, configuration, params, context, options);
        } else {
            let deferred: JQueryDeferred<ISuggestServiceQueryParams> = $.Deferred();
            return deferred.resolve(params).promise();
        }
    }

    public modifySuggestions(suggestions: IEssSuggestionResult[], context: IContext, options: any):
            JQueryPromise<Object[]> {
        let deferred: JQueryDeferred<Object[]> = $.Deferred();
        if (suggestions && suggestions.length > 0) {
            ExecutionHelper.shouldExecute(context, configuration)
                .done((shouldExecute) => {
                    suggestions.forEach((sugg: IEssSuggestionResult): void => {
                        sugg.showAsHierarchy = false;
                        if (shouldExecute) {
                            let obj: string[] = sugg.relation;
                            if (+sugg.index > 0 && sugg.hierarchyInfo) {
                                obj = sugg.hierarchyInfo.relation;
                            }
                            if (obj && (obj[0] === "child" || obj[0] === "nearby")) {
                                // Set the flag to show as hierarchy option
                                sugg.showAsHierarchy = true;
                            }
                        }
                    });
                })
                .always(() => {
                    deferred.resolve(suggestions);
                });
        } else {
            deferred.resolve(suggestions);
        }
        return deferred.promise();
    }
}
